<nav class="navbar navbar-expand-lg navbar-light py-0 main-header-nav">
    <div class="container main-header-menu">
        <a class="navbar-brand" href="/contact-us">
            <img src="../../../../../assets/redesignImages/UPS-Logo.png" height="45" alt="logo">
        </a>
        <div class="collapse navbar-collapse custom-nav-menu" id="navbarSupportedContent">
            <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                <li class="nav-item">
                    <a class="nav-link active" aria-current="page" href="/shipping-insurance/">Shipping
                        Insurance</a>
                </li>
                <li>
                    <hr class="dropdown-divider">
                </li>
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle ddown-menu" aria-current="page" routerLink="/business-services"
                        >Business Services<span class="sdrop"><img src=""></span></a>

                    <ul class="dropdown-menu dropdown-content" aria-labelledby="navbarDropdown">
                        <li><a class="dropdown-item" routerLink="/business-services/payment-services">Payment
                                Services</a>
                        </li>
                        <li><a class="dropdown-item"
                                href="/business-services/payment-services/merchant-services">Merchant
                                Services</a>
                        </li>
                        <li><a class="dropdown-item" href="/business-services/payment-services/cod">Enhanced C.O.D.
                                Services</a></li>
                        <li><a class="dropdown-item" href="/business-services/continuous-customs-bonds">Continuous
                                Trade Bonds</a></li>
                        <li><a class="dropdown-item"
                            href="../../../../../assets/COD_Direct_Enrollment_Form.pdf">Complete
                                Application</a>
                        </li>
                    </ul>
                </li>
                <li>
                    <hr class="dropdown-divider">
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="/claims/">Claims</a>
                </li>
                <li>
                    <hr class="dropdown-divider">
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="/resources/">Resources</a>
                </li>
                <li>
                    <hr class="dropdown-divider">
                </li>
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle ddown-menu" aria-current="page" href="/about">About Us<span
                            class="sdrop"><img src=""></span></a>

                    <ul class="dropdown-menu dropdown-content" aria-labelledby="navbarDropdown">
                        <li><a class="dropdown-item" href="/about/our-story">Our Story</a></li>
                        <li><a class="dropdown-item" href="/about/offices">Offices</a></li>
                        <li><a class="dropdown-item" href="/about/contact-us">Contact Us</a></li>
                        <li><a class="dropdown-item" href="/about/help-and-support">Help and Support</a></li>
                    </ul>
                </li>
                <li>
                    <hr class="dropdown-divider">
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="/get-a-quote">Get a Quote</a>

                </li>
                <li>
                    <hr class="dropdown-divider">
                </li>
            </ul>
            <div class="d-flex right-navigation">
                <ul class="right-inner-menu d-flex">
                    <li class="font-size-class"><a class="top-breadcrumb-hover" href="/about/contact-us">Contact
                            Us</a>
                    </li>
                    <li class="log-in-breadcrumb font-size-class"><a class="top-breadcrumb-hover-log"
                            href="https://online.upscapital.com/login" target="_blank" rel="noopener">Log
                            In</a></li>

                </ul>
            </div>
        </div>

        <div class="mobile-wrapper d-flex flex-row-reverse">
            <button (click)="toggleNavbar()" class="navbar-toggler" type="button" data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
                aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div>
                <form method="POST" action="/search" id="search-form" class="d-flex right-saerch flex-row-reverse">
                    <button class="btn btn-outline-secondary position-relative btn-search" type="button">
                        <img src="../../../../../assets/redesignImages/Search-button.png" alt="Search" width="17"
                            height="17" id="search-bt">
                        <!-- <span class="visually-hidden">searchButton</span> -->
                    </button>
                    <div class="input-group flex-nowrap d-none">
                        <input type="text" class="form-control" placeholder="Search" aria-label="Search"
                            aria-describedby="addon-wrapping" id="search-ip" name="search_term">
                        <input type="hidden" name="current_country" value="us-en">
                    </div>
                </form>
            </div>
        </div>

    </div>
</nav>